import { render, staticRenderFns } from "./NewTeamDialog.vue?vue&type=template&id=fa08ca90"
import script from "./NewTeamDialog.vue?vue&type=script&lang=js"
export * from "./NewTeamDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports